import React from 'react';
import { PropertyRow } from '../types';

export function useExpandedState() {
  const [state, setState] = React.useState(new Set<PropertyRow>());
  const toggleRow = React.useCallback((row: PropertyRow) => {
    setState(prev => {
      const next = new Set(prev);
      if (next.has(row)) {
        next.delete(row);
      } else {
        next.add(row);
      }
      return next;
    });
  }, []);
  return [state, toggleRow] as const;
}
